import {COUPON_CODE_STATUS_DELIVERED, COUPON_CODE_STATUS_NOT_USED, COUPON_CODE_STATUS_USED} from "./Constants";
import {useTranslation} from "react-i18next";
import {useTheme} from "@mui/material";


export const useStatusValuesCoupon = () => {
    const {t} = useTranslation(['salesmarketing']);
    const theme = useTheme();
    const getStatusColor = (status: string) => {
        switch (status) {
            case COUPON_CODE_STATUS_USED: return theme.palette.success.transparent;
            case COUPON_CODE_STATUS_DELIVERED: return theme.palette.error.transparent;
            case COUPON_CODE_STATUS_NOT_USED: return theme.palette.warning.transparent;
        }
    };

    const getStatusLabel = (status: string) => {
        switch (status) {
            case COUPON_CODE_STATUS_USED: return t('salesmarketing:coupon.statusValues.used');
            case COUPON_CODE_STATUS_DELIVERED: return t('salesmarketing:coupon.statusValues.delivered');
            case COUPON_CODE_STATUS_NOT_USED: return t('salesmarketing:coupon.statusValues.notUsed');
        }
    };

    return {
        getStatusColor,
        getStatusLabel
    }
}